module.exports = __webpack_public_path__ + "static/media/spradling-logo-portrait.5f8a2968.svg";